// extracted by mini-css-extract-plugin
export default {"btnpwd":"e202e2d9e6"};